import React, { useState } from 'react';
import Alert from '@mui/material/Alert'; 
import Box from '@mui/material/Box';
import Button from '@mui/material/Button'; 
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'; 
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import { put } from 'aws-amplify/api'; 
import { Link } from "react-router-dom";
import { v4 as uuid } from "uuid";  

const ERROR_MESSAGE = "Platform and/or tasking value field(s) are empty!";
const SUCCESS_MESSAGE = "Successfully submitted tasking. Refer to all entries ";
const platforms = [
    "Facebook", 
    "Instagram",
    "YouTube",
    "TikTok",
    "Twitter"
    ]; 
    
export default function AddUrgentTaskingForm(props) {  
    const [platform, setPlatform] = useState('');   
    const [pageUrl, setPageUrl] = useState('');
    const [pageName, setPageName] = useState('');
    const [pageSelectorAccountId, setPageSelectorAccountId] = useState('');
    const [pageSelectorUsername, setPageSelectorUsername] = useState('');
    const [status, setStatus] = useState(null); 
    const [openDialog, setOpenDialog] = useState(false);  
    const [openAlert, setOpenAlert] = useState(false);    
    
    const addPageTasking = async (pk) => {
        try {
            const putOperation = put({
                apiName: 'gccadhoctaskingapi',
                path: '/gccadhoctasking',
                options: {
                    body: {
                        PK: pk,
                        user: props.user.username, 
                        team: props.user.team,
                        pageUrl: pageUrl,
                        pageName: pageName,
                        pageSelectorAccountId: pageSelectorAccountId,
                        pageSelectorUsername: pageSelectorUsername, 
                        application: platform,  
                        date_created: new Date(),
                        date_created_epoch: Date.parse(new Date())
                        // date_created: new Date().toLocaleString(), 
                        // date_created_epoch: Date.parse(new Date().toLocaleString())
                    }
                }
            })
            await putOperation.response; 
        } catch (err) {
            setStatus(false); // Different error message needed
            console.log('PUT call failed: ', err);
        }    
    } 
 
    const handleConfirm = () => {
        if (platform === '' || pageUrl.trim() === '' || pageName.trim() === '' || pageSelectorAccountId.trim() === '' || pageSelectorUsername.trim() === '') {
            setStatus(false);
            setOpenAlert(true); 
        } else { 
            const pk = uuid().slice(0, 12); 
            setStatus(true);
            setOpenAlert(true);  
            addPageTasking(pk);
        } 
        setOpenDialog(false);   
    } 
    
    const handleReset = () => {
        setPlatform(''); 
        setPageUrl('');
        setPageName('');
        setPageSelectorAccountId('');
        setPageSelectorUsername('');
        setStatus(null);
        setOpenAlert(false); 
    }
    
    const handleOpen = () => {
        setOpenDialog(true);
    } 
    
    const handleClose = () => {
        setOpenDialog(false);
    } 
    
    let alert; 
    if (status) {
        alert = <Alert sx={{fontSize: '16px'}} severity="success" onClose={() => setOpenAlert(false)}>{SUCCESS_MESSAGE}<Link to="/social-media-urgent-tasking/view">here</Link>.</Alert>; 
    } else if (status === null) {
        alert = <div></div>;
    } else {
        alert = <Alert sx={{ fontSize: '16px' }} severity="error" onClose={() => setOpenAlert(false)}>{ERROR_MESSAGE}</Alert>;
    }
    
    return (
        <Box className='table-position'> 
            <React.Fragment> 
              <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {"Confirmation"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Please ensure that this record <strong>does not</strong> contain any code words.<br/>Are you sure you want to submit record?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" className='dialog-button' onClick={handleConfirm}>
                        <span className='dialog-button-text'>
                            CONFIRM
                        </span> 
                    </Button>
                    <Button variant="outlined" className='dialog-button' onClick={handleClose} autoFocus>
                        <span className='dialog-button-text'>
                            CANCEL
                        </span> 
                    </Button>
                </DialogActions>
              </Dialog>
            </React.Fragment> 
            <Paper elevation={0} className='table'> 
                <Box> 
                    <div className='table-header'>
                        Platform
                    </div>
                    <Box sx={{paddingLeft: '1%', paddingRight: '1%'}}>
                        <FormControl fullWidth>
                            <InputLabel size="small">Select a platform</InputLabel>
                            <Select  
                              value={platform}
                              label="Select a platform"
                              size="small"
                              onChange={(event) => setPlatform(event.target.value)}
                            >
                            {platforms.map(
                                (type, i) => ( 
                                    <MenuItem key={i} value={type}>{type}</MenuItem>
                                ))
                            }
                            </Select>
                        </FormControl>
                    </Box>    
                    <>
                        <div className='table-header'>
                            Tasking Value
                        </div> 
                        <Box sx={{paddingLeft: '1%', paddingRight: '1%'}} component="form" noValidate autoComplete="off">
                            <FormControl fullWidth> 
                                <TextField 
                                    value={pageName}
                                    id="outlined-basic" 
                                    size="small" 
                                    variant="outlined" 
                                    label="Post Name"
                                    onChange={(event) => setPageName(event.target.value)}
                                />     
                            </FormControl>
                            <FormControl fullWidth sx={{paddingTop: '0.7rem'}}> 
                                <TextField 
                                    value={pageUrl}
                                    id="outlined-basic" 
                                    size="small" 
                                    variant="outlined" 
                                    label="Post URL"
                                    onChange={(event) => setPageUrl(event.target.value)}
                                />     
                            </FormControl>
                            <FormControl fullWidth sx={{paddingTop: '0.7rem'}}> 
                                <TextField 
                                    value={pageSelectorAccountId}
                                    id="outlined-basic" 
                                    size="small" 
                                    variant="outlined" 
                                    label="Post Selector Account ID"
                                    onChange={(event) => setPageSelectorAccountId(event.target.value)}
                                />     
                            </FormControl>
                            <FormControl fullWidth sx={{paddingTop: '0.7rem'}}> 
                                <TextField 
                                    value={pageSelectorUsername}
                                    id="outlined-basic" 
                                    size="small" 
                                    variant="outlined" 
                                    label="Post Selector Username"
                                    onChange={(event) => setPageSelectorUsername(event.target.value)}
                                />     
                            </FormControl>  
                        </Box>  
                    </>  
                </Box>
                <Box className='button-box-position'>
                    <div className='button-position'>
                        <Button className='form-button' onClick={handleOpen} variant="contained">
                            <span className='button-text'>
                                SUBMIT
                            </span> 
                        </Button>
                        <Button className='form-button' onClick={handleReset} variant="contained">
                            <span className='button-text'>
                                RESET
                            </span>  
                        </Button>
                    </div>
                </Box> 
            </Paper>   
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={openAlert}> 
                {alert} 
            </Snackbar>  
        </Box>
    );
}   